<sd-border-wrapper [hasBorder]="false">
  @if (!!store) {
    <div class="c__content">
      <div class="c__left">
        <sd-icon name="icon-check-circle" aria-hidden="true" [size]="iconSize.medium" />
      </div>
      <div class="c__right">
        <span class="c__selected-relay-title">
          {{ 'checkout.shipping.pickup.selected' |translate}}
        </span>
      </div>
    </div>
  }
</sd-border-wrapper>
